import { render, staticRenderFns } from "./authorityDialog.vue?vue&type=template&id=49398ba7&"
import script from "./authorityDialog.vue?vue&type=script&lang=js&"
export * from "./authorityDialog.vue?vue&type=script&lang=js&"
import style0 from "./authorityDialog.vue?vue&type=style&index=0&id=49398ba7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports